export default "__VITE_ASSET__CmpcrPj2__"